var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDateWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_1030",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 1030",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14.595,
    viewBox: "0 0 14 14.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_515",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 515",
    d: "M1309.63,953.065h-1.5v-1.62a.38.38,0,0,0-.38-.38h-1.25a.378.378,0,0,0-.37.38v1.62h-4v-1.62a.38.38,0,0,0-.38-.38h-1.25a.378.378,0,0,0-.37.38v1.62h-1.5a1.5,1.5,0,0,0-1.5,1.5v9.595a1.5,1.5,0,0,0,1.5,1.5h11a1.5,1.5,0,0,0,1.5-1.5v-9.595A1.5,1.5,0,0,0,1309.63,953.065Zm.5,11.095a.5.5,0,0,1-.5.5h-11a.5.5,0,0,1-.5-.5v-7.515h12Z",
    transform: "translate(-1297.13 -951.065)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_516",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 516",
    d: "M1300.5,963.17h1.25a.378.378,0,0,0,.38-.37v-1.25a.38.38,0,0,0-.38-.38h-1.25a.378.378,0,0,0-.37.38v1.25A.376.376,0,0,0,1300.5,963.17Z",
    transform: "translate(-1297.13 -951.065)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_517",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 517",
    d: "M1300.5,960.17h1.25a.378.378,0,0,0,.38-.37v-1.25a.38.38,0,0,0-.38-.38h-1.25a.378.378,0,0,0-.37.38v1.25A.376.376,0,0,0,1300.5,960.17Z",
    transform: "translate(-1297.13 -951.065)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_518",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 518",
    d: "M1303.5,963.17h1.25a.378.378,0,0,0,.38-.37v-1.25a.38.38,0,0,0-.38-.38h-1.25a.378.378,0,0,0-.37.38v1.25A.376.376,0,0,0,1303.5,963.17Z",
    transform: "translate(-1297.13 -951.065)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_519",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 519",
    d: "M1303.5,960.17h1.25a.378.378,0,0,0,.38-.37v-1.25a.38.38,0,0,0-.38-.38h-1.25a.378.378,0,0,0-.37.38v1.25A.376.376,0,0,0,1303.5,960.17Z",
    transform: "translate(-1297.13 -951.065)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_520",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 520",
    d: "M1306.5,963.17h1.25a.378.378,0,0,0,.38-.37v-1.25a.38.38,0,0,0-.38-.38h-1.25a.378.378,0,0,0-.37.38v1.25A.376.376,0,0,0,1306.5,963.17Z",
    transform: "translate(-1297.13 -951.065)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_521",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 521",
    d: "M1306.5,960.17h1.25a.378.378,0,0,0,.38-.37v-1.25a.38.38,0,0,0-.38-.38h-1.25a.378.378,0,0,0-.37.38v1.25A.376.376,0,0,0,1306.5,960.17Z",
    transform: "translate(-1297.13 -951.065)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDateWhite);
export default __webpack_public_path__ + "static/media/icon_date_white.eb501da20c0e3f35720e5e059e229c13.svg";
export { ForwardRef as ReactComponent };